import create from "zustand";
import { defaultFeedbackData, Feedback, Type } from "../components/Feedback/Feedback";

export interface FeedbackStoreState {
    feedback: Feedback;
    setPriority: (priority: number) => void;
    setEtop: (value: string) => void;
    setProblem: (value: string) => void;
    setSolution: (value?: string) => void;
    reset: (type: Type) => void;
}

export const useFeedbackStore = create<FeedbackStoreState>((set, get) => ({
    feedback: defaultFeedbackData,
    setPriority: (priority: number) => set({ feedback: { ...get().feedback, priority } }),
    setEtop: (value: string) => set({ feedback: { ...get().feedback, estimatedOccurencePeriod: value } }),
    setProblem: (problem: string) => set({ feedback: { ...get().feedback, problem } }),
    setSolution: (suggestedSolution?: string) => set({ feedback: { ...get().feedback, suggestedSolution } }),
    reset: (type: Type) => set({ feedback: { ...defaultFeedbackData, type } }),
}));
